export default "__VITE_ASSET__u0Tj_Yqz__"